import React from 'react';
import { PanelHeader, Icon } from 'js/components';
import { Card, CardBody } from 'reactstrap';

import { faPersonHiking } from '@fortawesome/pro-regular-svg-icons';

function NoHome() {
  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <Card>
          <CardBody>
            <div className="media text-muted mt-4 mb-4">
              <Icon
                icon={faPersonHiking}
                size="4x"
                className="mr-3"
                fixedWidth
              />
              <div className="media-body">
                <h3>Looks like you're on a solo adventure!</h3>
                <p>
                  You're not currently a member of any workspaces. Reach out to
                  your administrator for an invite to join the team.
                </p>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default NoHome;
